import { Component, Input } from '@angular/core';

@Component({
    selector: 'cart-row-extra-fields',
    templateUrl: './cart.row.extra-fields.component.html',
    styleUrls: ['./../../cart.component.scss']
})
export class CartRowExtraFieldsComponent {
    @Input('extraFields') extraFields: Array<any>;
}



// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/app/cart/row/extra-fields/cart.row.extra-fields.component.ts